import { CardMedia, Typography } from "@mui/material";
import React from "react";
import { EditButton, Show, SimpleShowLayout, TopToolbar, useShowContext } from "react-admin";
import { Permission } from "../../components";
import { PERMISSIONS } from "../../constants";

const titleSx = {
  margin: '10px 0 10px 0',
  textAlign: 'start',
  fontWeight: 'bold'
};

const iframeSx = {
  height: '80vh',
};

const NewsShow = () => {

  const ShowLayout = () => {
    const { record } = useShowContext();

    if (!record) { return null; }

    return (
      <SimpleShowLayout>
        <Typography variant="h4" sx={titleSx}>{record.title}</Typography>
        <CardMedia sx={iframeSx} component="iframe" src={record.link} />
      </SimpleShowLayout>
    );
  }

  const NewsActions = () => {
    return (
      <TopToolbar>
        <Permission permission={PERMISSIONS.NEWS}>
          <EditButton />
        </Permission>
      </TopToolbar>
    );
  }

  return (
    <Show title="Novidade" actions={<NewsActions />}>
      <ShowLayout />
    </Show>
  );
}

export default NewsShow;
